const TYPING_TIMEOUT_MS = 3000;

let _typingTimer = null;

export const clearTypingIndicator = (container) => {
  clearTimeout(_typingTimer);
  const messages = container.querySelector('.aws-chatkit-messages');
  if (!messages) return;
  const indicator = messages.querySelector('.aws-chatkit-typing');
  if (indicator) indicator.remove();
};

export const showTypingIndicator = (container, displayName) => {
  const messages = container.querySelector('.aws-chatkit-messages');
  if (!messages) return;

  let indicator = messages.querySelector('.aws-chatkit-typing');
  if (!indicator) {
    indicator = document.createElement('div');
    indicator.className = 'aws-chatkit-typing';
    messages.appendChild(indicator);
  }
  indicator.textContent = `${displayName} is typing...`;
  messages.scrollTop = messages.scrollHeight;

  clearTimeout(_typingTimer);
  _typingTimer = setTimeout(() => clearTypingIndicator(container), TYPING_TIMEOUT_MS);
};
